module.exports = __webpack_public_path__ + "static/media/insta-2-min.ba3371b6.png";